import { createContext } from 'react';
const CurrencyContext = createContext({
    selectedCurrency: '',
    isSecondaryCurrencyDisplay: false,
    setIsSecondaryCurrencyDisplay: () => null,
});
export default CurrencyContext;
//# sourceMappingURL=CurrencyContext.js.map